import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { CountriesState } from '@nibtravel/shared/data-access/countries';
import { ListPipe } from '@nibtravel/shared/ui/pipes/list';
import { IDestinationCountry, QuoteType } from '@nibtravel/shared/util/models';
import { QuoteState } from '@nibtravel/shared/data-access/quote';

@Pipe({ name: 'destination' })
export class DestinationPipe implements PipeTransform {
  config!: IDestinationCountry[];

  constructor(store: Store, private listPipe: ListPipe) {
    const quoteType = store.selectSnapshot(QuoteState.quoteType);
    if (quoteType === QuoteType.SingleTrip) {
      this.config = store.selectSnapshot(
        CountriesState.destinationCountriesList
      );
    } else {
      this.config = store.selectSnapshot(CountriesState.destinationRegionsList);
    }
  }

  transform(codes: string | string[]): any {
    if (!codes || codes.length === 0) {
      return '';
    }

    if (typeof codes === 'string') {
      codes = [codes];
    }

    let list: string[];
    if (this.config) {
      list = codes.map(
        (c: string) =>
          this.config
            .filter((dc) => dc.code === c)
            .map((dc) => dc.sentenceName || dc.name)[0] || c
      );
    } else {
      list = codes;
    }

    return this.listPipe.transform(list);
  }
}
